export default __webpack_public_path__ + "static/media/punks_loading.1e877c51.gif";